import React, { useState } from "react";

import { gql } from "@examspark/api";
import { Button, Modal, ModalProps } from "@examspark/common-ui";
import { Resource } from "@examspark/types";

import { useAuthorizationContext } from "../../../../hooks/useAuthorizationContext";
import { itemsGql } from "../../../../hooks/useSearch";
import { ItemPickerSearchToolbar } from "../item-picker/ItemPickerToolbar";

import PassagePicker from "./PassagePicker";

const PassagePickerModal = (
  props: ModalProps & {
    multiple?: boolean;
    onSubmit?: (items: Resource[]) => void;
    searchToolbar?: typeof ItemPickerSearchToolbar;
  },
) => {
  const [selected, setSelected] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const authorizationContext = useAuthorizationContext();

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const items: Resource[] = [];

    for (const passageItem of selected) {
      const contextItems = await gql.operations.resource.search({
        fields: itemsGql,
        variables: {
          filter: {
            contextIds: {
              eq: passageItem,
            },
          },
          authorizationContext,
        },
      });

      if (contextItems.data?.search.items) {
        items.push(
          ...contextItems.data.search.items.sort((a, b) =>
            (a.name ?? "").localeCompare(b.name ?? ""),
          ),
        );
      }
    }

    setIsSubmitting(false);
    props.onSubmit?.(items);
    setSelected([]);
  };

  return (
    <Modal
      size="full"
      flexBodyColumn
      buttons={
        <>
          <Button
            title=""
            data-cy="modal-button-submit"
            autoFocus
            variant="contained"
            color="primary"
            onClick={async () => {
              handleSubmit();
            }}
            // isLoading={props.isLoading || isSubmitting}
            disabled={isSubmitting || !selected.length}
          >
            Select Items from {selected.length}{" "}
            {selected.length === 1 ? "Passage" : "Passages"}
          </Button>
        </>
      }
      title="Select Passage"
      {...props}
    >
      <PassagePicker
        onSelect={(itemIds) => {
          console.log("items", itemIds);
          setSelected(itemIds);
        }}
      />
    </Modal>
  );
};

export default PassagePickerModal;
